export default {
  GK: { name: "GK", height: 0 },
  D: { name: "D", height: 1 },
  DM: { name: "DM", height: 2 },
  M: { name: "M", height: 3 },
  AM: { name: "AM", height: 4 },
  ST: { name: "ST", height: 5 },
}
